import React from 'react';
import { CreateAccountVendor } from '../components/Auth-Designer/CreateAccountVendor';

const VendorRegisterPage = () => {
  return (
    <main>
      <CreateAccountVendor />
    </main>
  );
};

export default VendorRegisterPage;